export enum TooltipPlacement {
  TopLeft = 'topLeft',
  Top = 'top',
  TopRight = 'topRight',
  LeftTop = 'leftTop',
  Left = 'left',
  LeftBottom = 'leftBottom',
  RightTop = 'rightTop',
  Right = 'right',
  RightBottom = 'rightBottom',
  BottomLeft = 'bottomLeft',
  Bottom = 'bottom',
  BottomRight = 'bottomRight'
}
